import { I18n } from "aws-amplify";
import { TextField } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import UnCheckIcon from "../../project/settingCategory/UnCheckIcon";
import CheckedIcon from "../../project/settingCategory/CheckedIcon";

export default function IPRestrictionSetting({
  //state
  usingIpAddressRestrict,
  error,
  ipAddressRange,
  changeIpAddressRange,
  //setState
  setError,
  setIsEdited,
  setUsingIpAddressRestrict,
  setIpAddressRange,
  //event
  onChangeUsingIpAddressRestrict,
  onChangeIpAddressRange
}) {
  return (
    <>
      <div className="org-profile-wrap-footer">
        <div
          className="org-profile-wrap-title"
          data-cy="org-profile-header-title"
        >
          {I18n.get("LABEL-FUNCTION-IP-RESTRICTION")}
        </div>
        <div  className="horizontal-field">
            <div className="title-name setting-ai-function">
                {I18n.get("APPLY_IP_ADDRESS_RESTRICTION")}
            </div>
            <div className="switch-check setting-ai-function"> 
                <input
                    name="ipAddressRestrict"
                    id="setting-ipAddress-switch-id"
                    type="checkbox"
                    checked={usingIpAddressRestrict}
                    onChange={e => {
                        const usingIpAddressRestrictValue = !usingIpAddressRestrict;
                        onChangeUsingIpAddressRestrict(
                            usingIpAddressRestrictValue,
                            setUsingIpAddressRestrict,
                            error,
                            setError, 
                            setIsEdited
                        );
                    }}
                />
                <label htmlFor="setting-ipAddress-switch-id"></label>
            </div>
        </div>
        <div className="groupSettingItem ipaddress-range">
          <div className="embeddedCode-label my-3">
            {I18n.get("IP_ADDRESS_ORG_SETTING_DESCRIPTION")}
          </div>
          <TextField
            id={!ipAddressRange && "ipaddress-placeholder"}
            multiline
            fullWidth
            variant="outlined"
            minRows={5}
            maxRows={5}
            className="form-control-wrapInput form-control-hg40"
            value={ipAddressRange}
            onChange={e =>
              onChangeIpAddressRange(
                e.target.value,
                setIpAddressRange,
                setIsEdited
              )
            }
            onBlur={e =>
              changeIpAddressRange(
                e.target.value,
                setIpAddressRange,
                error,
                setError,
                setIsEdited
              )
            }
            disabled={!usingIpAddressRestrict}
            error={error?.ipAddressRange ? true : false}
            helperText={error?.ipAddressRange}
          />
        </div>
      </div>
    </>
  );
}
